import type { Interceptor } from '@connectrpc/connect'
import { trace, context, propagation } from '@opentelemetry/api'

const tracer = trace.getTracer('default')

// oxlint-disable-next-line require-await
export const traceInterceptor: Interceptor = next => async req => {
  const spanName = `${req.service.typeName}.${req.method.name}`

  return tracer.startActiveSpan(spanName, async span => {
    const data: Record<string, string> = {}
    propagation.inject(context.active(), data)

    // oxlint-disable-next-line guard-for-in
    for (const key in data) {
      req.header.set(key, data[key])
    }

    // add request metadata as span attributes for better observability
    span.setAttributes({
      'rpc.service': req.service.typeName,
      'rpc.method': req.method.name,
      'rpc.url': req.url,
    })

    try {
      const response = await next(req)
      span.setStatus({ code: 0 })
      return response
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error'
      span.setStatus({ code: 1, message: errorMessage })

      // add error details as span attributes
      if (error instanceof Error) {
        span.setAttributes({
          'error.type': error.constructor.name,
          'error.message': errorMessage,
        })
      }

      // rethrow so the error is handled by the caller
      throw error
    } finally {
      span.end()
    }
  })
}
